import React from "react";
import { connect } from "dva";
import moment from "moment";
import { WizTableForm, WizClassifySelect } from "../../../common";
import { component_tool, framework_tool, utils_tool } from "@/tool";
let { WizContainer, modelUtils } = framework_tool;
let {
    WizButton,
    WizDataTable,
    WizModal, WizRow, WizCol, WizDivider
} = component_tool;
import { AudienceGroupItem } from '@/components';

let { Session } = utils_tool;

const formatterDate = (val) => {
    return val ? moment(val).format("YYYY-MM-DD HH:mm") : "";
};

const getParamRecord = (history) => {
    let record = {}
    if (history.location && (history.location.pathname === '/biz/label/featureContent')) {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('featureContentPreview', record)
        } else {
            record = Session.get('featureContentPreview') || {}
        }
    }
    return record
}

class LabelFeatureContent extends WizContainer {
    componentName = "LabelFeatureContent";

    constructor(props) {
        super(props);
        let labelRecord = {}
        if (props && props.history) {
            let { history } = props
            labelRecord = getParamRecord(history)
        }
        this.labelRecord = labelRecord
        this.state = {
            labelId: props.labelId || labelRecord.id,
            visible: false,
            search: {},
            timestamp: new Date().getTime(),
            programList: [],
            programIds: []
        };
    }

    _componentDidMount() {
        this._getFeatureContent();
    }

    _getFeatureContent = (values = {}) => {
        let { labelId } = this.state;
        if (labelId) {
            this.doActions([
                {
                    path: 'label/labelFeatureContent',
                    payload: {
                        key: 'labelFeatureContent',
                        apiParams: { labelId: this.state.labelId }
                    }
                },
            ]);
        }
    };

    propsAndStateOnChange = {
        create: this._createOnChange.bind(this),
        labelFeatureContent: this._labelFeatureContent.bind(this)
    };

    _labelFeatureContent(nextProps, nextState) {
        let { labelFeatureContent } = nextProps
        if (labelFeatureContent.code === 1) {
            if (labelFeatureContent && labelFeatureContent.success) {
                let { list } = labelFeatureContent.data
                nextState.programList = list
                let programIds = []
                Array.isArray(list) && list.length && list.forEach(item => {
                    programIds.push(item.id)
                })
                nextState.programIds = programIds
            }
        } else {
            wizNotice.error('获取数据失败：' + nextProps.labelFeatureContent.msg);
        }
        return true;
    }

    _createOnChange(nextProps, nextState) {
        if (nextProps.create.code === 1) {
            wizNotice.success("保存成功");
            this.jumpPage('replace', '/biz/label')
        } else {
            wizNotice.error(
                (nextProps.create && nextProps.create.msg) || "操作失败,请稍后尝试"
            );
        }
        return true;
    }

    _columns = () => {
        let listColumns = [
            {
                title: "业务名称",
                name: "name",
                dataIndex: "name",
                tableItem: {},
            },
            {
                title: "业务编码",
                name: "scoId",
                dataIndex: "scoId",
                tableItem: {},
            },
            {
                title: "业务",
                name: "bizType",
                dataIndex: "bizType",
                tableItem: {
                    render: (text, record) => {
                        return "在线课程"
                    }
                },
            },
            {
                title: "业务时间",
                name: "bizTime",
                dataIndex: "bizTime",
                tableItem: {
                    render: (text, record) => {
                        const { startDate, endDate } = record;
                        const bizTime = formatterDate(startDate) + " ~" + formatterDate(endDate);
                        return bizTime
                    }
                },
            },
            {
                title: "状态",
                name: "status",
                dataIndex: "status",
                dict: [
                    { code: 0, codeName: "草稿" },
                    { code: 1, codeName: "发布" },
                    { code: 2, codeName: "关闭" }
                ],
                tableItem: {},
            },
            {
                title: "操作",
                tableItem: {
                    render: (text, record) => {
                        return (
                            <WizDataTable.Oper>
                                <AudienceGroupItem btnText="查看受众" isModal={true} {...record.authData} />
                                <WizDivider type="vertical" />
                                <WizButton tooltip="删除" onClick={() => WizModal.confirm({
                                    title: '确认删除么',
                                    onOk: () => this._delFeatureContent(record.id),
                                    onCancel() { }
                                })}>删除</WizButton>
                            </WizDataTable.Oper>
                        );
                    },
                },
            },
        ];
        let programColumns = [
            {
                title: "课程名称",
                name: "name",
                dataIndex: "name",
                tableItem: {
                    width: 200
                },
                searchItem: {
                },
            },
            {
                name: "id",
                formItem: {
                    type: "hidden"
                }
            },
            {
                title: "课程编码",
                name: "scoId",
                dataIndex: "scoId",
                tableItem: {
                    width: 220
                },
                searchItem: {},
            },
            {
                title: "课程分类",
                name: "programCategoryIds",
                dataIndex: "programCategoryIds",
                searchItem: {
                    type: 'diy',
                    diy: WizClassifySelect,
                    returnKey: true,
                    wizTreeSelectListProps: {
                        checkable: true,
                        itemProps: {
                            icon: 'unordered-list',
                            title: '课程分类',
                            tips: '请勾选所属课程分类'
                        },
                        treeProps: { checkStrictly: true }
                    },
                    apiProps: { type: 1 },
                    selectProps: {
                        placeholder: '请选择课程分类'
                    },
                },
            },
            {
                title: "课程分类",
                name: "programCategoryNames",
                dataIndex: "programCategoryNames",
                tableItem: {
                    width: 220
                }
            },
            {
                title: "课程时间",
                name: "programDate",
                dataIndex: "programDate",
                tableItem: {
                    width: 300,
                    render: (text, record) => {
                        const { startDate, endDate } = record;
                        const programDate = formatterDate(startDate) + " ~" + formatterDate(endDate);
                        return programDate
                    }
                },
                searchItem: {
                    type: 'date~',
                    showTime: false,
                    format: 'YYYY-MM-DD'
                },
            }

        ]
        return { listColumns, programColumns };
    };

    _onRowDisabled = (record) => {
        let disabled = false;
        let programId = record.id;
        let { programList } = this.state;
        programList && programList.length && programList.forEach((item) => {
            if (item.id === programId) {
                disabled = true;
                return;
            }
        });
        return disabled;
    };

    _saveAndBack = () => {
        let { labelId, programIds } = this.state
        this.doAction({
            path: "label/addFeatureContent",
            payload: {
                key: "createLabelFeatureContent",
                apiParams: {
                    labelId: labelId,
                    programIds: programIds,
                },
            },
        });
    }

    _delFeatureContent = (programId) => {
        let { programIds, programList } = this.state
        programList = programList.filter(item => item.id !== programId)
        programIds = programIds.filter(item => item !== programId)
        this.setState({ programIds, programList })
    }

    _prev = () => {
        this.props.prevFunc && this.props.prevFunc()
    }

    _onReset = () => {
        this._getFeatureContent();
    }

    _render() {
        let { visible, timestamp, programList, programIds } = this.state;
        let { listColumns, programColumns } = this._columns();
        let dataTableProps = {
            loading: this.props.labelLoading,
            columns: listColumns,
            rowKey: "id",
            dataItems: {},
            dataSource: programList || [],
            showNum: false,
            isScroll: true,
            pagination: false,
            bordered: true,
        };
        let tableFormProps = {
            key: "key_" + timestamp,
            visible,
            cols: {
                xs: 12,
                md: 12,
                xl: 12,
            },
            showSelect: false,
            columns: programColumns,
            tableApi: {
                path: "program/getListByPage",
                apiParams: { status: 1 },
            },
            rowName: "name",
            selectType: "checkbox",
            tableProps: {
                needOnRowSelect: (record) => {
                    let disabled = this._onRowDisabled(record);
                    return !disabled;
                },
                rowSelection: {
                    getCheckboxProps: (record) => {
                        let disabled = this._onRowDisabled(record);
                        return { disabled };
                    },
                },
            },
            renderValue: () => {
                return (
                    <div className="btns-toolbar-group">
                        <br/>
                        <WizButton
                            title="推荐内容"
                            onClick={() =>
                                this.setState({
                                    visible: true,
                                    timestamp: new Date().getTime(),
                                })
                            }
                        >
                            {"推荐内容"}
                        </WizButton>
                    </div>
                );
            },
            onSubmit: (values) => {
                let { value, valueRows } = values
                Array.isArray(valueRows) && valueRows.length && valueRows.forEach(v => {
                    programList.push(v)
                    programIds.push(v.id)
                })

                this.setState({ visible: false, programList: programList, programIds: programIds });
            },
            onCancel: () => this.setState({ visible: false }),
        };
        let flag = false
        if (this.labelRecord && this.labelRecord.id) {
            flag = true
        }
        return (
            <div className="table-div">
                <WizTableForm {...tableFormProps} />
                <WizDataTable {...dataTableProps} />
                <br/>
                <WizRow className="form-btns row-item">
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        {flag ? null : <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>}
                        <WizButton title='保存并返回' type='primary' onClick={this._saveAndBack}>保存并返回</WizButton>
                        <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
                    </WizCol>
                </WizRow>
                <br/>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { label } = state;
    const labelFeatureContent = modelUtils.getModelEntity(label, "labelFeatureContent");
    const create = modelUtils.getModelEntity(
        label,
        "createLabelFeatureContent"
    );
    const load = modelUtils.getLoadingState(state, "label");
    return {
        labelFeatureContent,
        create,
        ...load,
    };
};

export default connect(mapStateToProps)(LabelFeatureContent);
